import useFetchChartData from '@hooks/useFetchChartData'
import {
  AnalyticsGraphDataBase,
  FetchUserAnalyticsGraphParams,
} from '@models/user/UserAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { plethorePalette } from '@utils/colors'
import dayjs from 'dayjs'
import { Area, AreaChart, Tooltip, XAxis, YAxis } from 'recharts'
import { DateAxisTick, NumberFormatedAxisTick } from '../common/AxisTicks'
import BaseChart from '../common/BaseChart'
import CustomTooltip from '../common/CustomTooltip'
import { ChartCommonProps } from '../common/chartCommonProps'

const DailyActiveUser = ({ displayMode = 'full' }: ChartCommonProps) => {
  const { data, isLoading, error } = useFetchChartData<
    FetchUserAnalyticsGraphParams,
    AnalyticsGraphDataBase
  >({
    entity: 'user',
    kind: 'daily-active-users',
    fetchFunction: fetchAnalyticsGraph,
  })
  return (
    <BaseChart
      title={'Daily active users'}
      help={'Trend of unique users per day over the selected time range.'}
      data={data}
      isLoading={isLoading}
      error={error}
      height={displayMode == 'compact' ? 60 : 350}
      displayOnlyChart={displayMode == 'compact'}
    >
      <AreaChart data={data}>
        {displayMode == 'full' && (
          <>
            <YAxis
              dataKey="count"
              tickLine={false}
              stroke={'#bbb'}
              width={30}
              tick={(props) => <NumberFormatedAxisTick {...props} />}
            />
            <XAxis
              dataKey="label"
              tickLine={false}
              stroke={'#bbb'}
              height={20}
              tick={(props) => <DateAxisTick {...props} />}
            />
          </>
        )}
        <Tooltip
          content={(props) => (
            <CustomTooltip
              type="bar"
              {...props}
              customLabelFormatter={(payload) => {
                return dayjs(payload.label).format('D MMM YY')
              }}
            />
          )}
        />
        <Area
          dataKey="count"
          type="monotone"
          fill={displayMode == 'full' ? plethorePalette[3] : 'transparent'}
          stroke={plethorePalette[5]}
          strokeWidth={displayMode == 'full' ? 1 : 2}
        />
      </AreaChart>
    </BaseChart>
  )
}

export default DailyActiveUser
